module.exports = __webpack_public_path__ + "static/media/LA.6f5ce7a9.svg";